import React from 'react'

export type ArrowRightCircleIconProps = {
  size?: number
  color?: string
  className?: string
}

// Association-status glyph (arrow in circle) shown on the "Tailgate-enabled"
// StatusPill. Defaults to currentColor so it inherits the pill text color
// (precedent: CheckSquareIcon).
export const ArrowRightCircleIcon = ({
  size = 16,
  color = 'currentColor',
  className,
}: ArrowRightCircleIconProps) => (
  <svg
    className={className}
    fill='none'
    height={size}
    viewBox='0 0 16 16'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.64428 5.09633L10.1922 7.64428L7.64428 10.1922M10.1922 7.64428H5.09633M14.0141 7.64428C14.0141 11.1623 11.1623 14.0141 7.64428 14.0141C4.1263 14.0141 1.27441 11.1623 1.27441 7.64428C1.27441 4.1263 4.1263 1.27441 7.64428 1.27441C11.1623 1.27441 14.0141 4.1263 14.0141 7.64428Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.27397'
    />
  </svg>
)
